import { generateRandomValue } from '../../generalExternalFunctions'

export const formGroupsParticipants = (nodes, players, type) => {
	const participants = nodes?.filter(node => node?.type !== 'outgoing' || node?.type !== 'middle')
		.map((node) => {
			if (type === 'singles') {
				const participant = players?.find((p) => p?.uid === node?.player_uid)

				console.log(participant)

				return {
					nodeUid: participant?.uid,
					orderNumber: node?.order_number,
					name: `${participant?.last_name} ${participant?.first_name}`
				}
			} else if (type === 'doubles') {
				const participant = players?.find((p) => p?.uid === node?.double_uid)

				return {
					nodeUid: participant?.uid,
					orderNumber: node?.order_number,
					firstPlayerNode: participant?.player1?.uid,
					secondPlayerNode: participant?.player1?.uid,
					firstPlayerName: `${participant?.player1?.last_name} ${participant?.player1?.first_name}`,
					secondPlayerName: `${participant?.player2?.last_name} ${participant?.player2?.first_name}`
				}
			}
		})

	return participants
}

export const addEmptyPlayerInList = (nodesList) => {
	const updatedList = [...nodesList]

	updatedList.unshift({
		placed: false,
		name: '---',
		nodeUid: generateRandomValue(),
		orderNumber: 0,
		playerUid: null,
		rating: '-',
		emptyPlayer: true,
		noPlayer: true
	})

	return updatedList
}

export const existingMatches = (grp) => {
	if (grp) {
		for (const m of grp.matches || []) {
			if (m && m.sets && m.sets.length > 0) {
				return true
			}
		}
	}
	return false
}